import { render, staticRenderFns } from "./GlobalFooter.vue?vue&type=template&id=12a398fc&scoped=true&"
import script from "./GlobalFooter.vue?vue&type=script&lang=js&"
export * from "./GlobalFooter.vue?vue&type=script&lang=js&"
import style0 from "./GlobalFooter.vue?vue&type=style&index=0&id=12a398fc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12a398fc",
  null
  
)

export default component.exports